import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/Login";

export default function Invitation() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [invalid, setInvalid] = useState(false);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const { refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/auth/invitation/${token}`).then(({ data }) => setInfo(data)).catch(() => setInvalid(true));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("La contraseña debe tener al menos 8 caracteres.");
    if (password !== confirm) return toast.error("Las contraseñas no coinciden.");
    setLoading(true);
    try {
      await api.post("/auth/accept-invitation", { token, password });
      const currentUser = await refresh();
      if (!currentUser) throw new Error("No se pudo cargar la sesión.");
      toast.success("Acceso activado");
      navigate("/inicio");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (invalid) {
    return (
      <AuthShell title="Invitación no válida" subtitle="Este enlace de invitación no es válido o ha caducado. Contacte con DDP para recibir uno nuevo." />
    );
  }

  return (
    <AuthShell title="Activar su acceso" subtitle={info ? `${info.firm_name} · ${info.email}` : "Cargando…"}>
      <form onSubmit={submit} data-testid="invitation-form">
        <label className="ddp-label">Cree su contraseña</label>
        <input type="password" className="ddp-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="inv-password" required />
        <label className="ddp-label" style={{ marginTop: 16 }}>Repita la contraseña</label>
        <input type="password" className="ddp-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="inv-confirm" required />
        <button type="submit" disabled={loading || !info} data-testid="inv-submit" className="ddp-btn ddp-btn-primary" style={{ width: "100%", marginTop: 24 }}>
          {loading ? "Activando…" : "Activar acceso"}
        </button>
      </form>
    </AuthShell>
  );
}
